import { ILxsBillingDocument } from '../actions/get-billing-documents.action';

export const mapBillingTypeToText = (data: ILxsBillingDocument[], key: string): string => {
    const datas = Array.from(data.values());
    const foundByCode = datas.find(value => value.BillingType === key);
    if (foundByCode) {
        return foundByCode.BillingTypeText || '';
    }
    return key;
};
